var chunkMapping = {
	"1505": [
		1505
	],
	"2390": [
		2390
	],
	"2483": [
		2483
	],
	"2501": [
		2501
	],
	"2847": [
		2847
	],
	"3345": [
		3345
	],
	"3528": [
		3528
	],
	"4204": [
		4204
	],
	"4553": [
		4553
	],
	"4873": [
		4873
	],
	"5499": [
		5499
	],
	"6238": [
		6238
	],
	"6688": [
		6688
	],
	"7643": [
		222,
		3646,
		5106,
		5407
	],
	"8181": [
		599,
		6234
	],
	"8225": [
		8225
	],
	"8873": [
		3013
	]
};
var idToExternalAndNameMapping = {
	"222": [
		"default",
		"./SupportGuideOverlay",
		9129
	],
	"599": [
		"default",
		"./Aside",
		5807
	],
	"1505": [
		"default",
		"./Catalog",
		3833
	],
	"2390": [
		"default",
		"./KitchenDetail",
		3810
	],
	"2483": [
		"default",
		"./Header",
		5807
	],
	"2501": [
		"default",
		"./CartToast",
		4363
	],
	"2847": [
		"default",
		"./SearchView",
		5443
	],
	"3013": [
		"default",
		"./PIPView",
		3810
	],
	"3345": [
		"default",
		"./ScrollToTop",
		3569
	],
	"3528": [
		"default",
		"./CopilotFrame",
		4363
	],
	"3646": [
		"default",
		"./CustomerProvider",
		3258
	],
	"4204": [
		"default",
		"./Browse",
		3833
	],
	"4553": [
		"default",
		"./CustomerOrders",
		4363
	],
	"4873": [
		"default",
		"./CombinationView",
		3810
	],
	"5106": [
		"default",
		"./CartStoreProvider",
		4363
	],
	"5407": [
		"default",
		"./ServiceProvider",
		4363
	],
	"5499": [
		"default",
		"./languageService",
		3569
	],
	"6234": [
		"default",
		"./layoutSizeHelper",
		3569
	],
	"6238": [
		"default",
		"./colorHelper",
		3569
	],
	"6688": [
		"default",
		"./Admin",
		6443
	],
	"8225": [
		"default",
		"./CartView",
		4363
	]
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			var getScope = __webpack_require__.R;
			if(!getScope) getScope = [];
			var data = idToExternalAndNameMapping[id];
			if(getScope.indexOf(data) >= 0) return;
			getScope.push(data);
			if(data.p) return promises.push(data.p);
			var onError = (error) => {
				if(!error) error = new Error("Container missing");
				if(typeof error.message === "string")
					error.message += '\nwhile loading "' + data[1] + '" from ' + data[2];
				__webpack_require__.m[id] = () => {
					throw error;
				}
				data.p = 0;
			};
			var handleFunction = (fn, arg1, arg2, d, next, first) => {
				try {
					var promise = fn(arg1, arg2);
					if(promise && promise.then) {
						var p = promise.then((result) => (next(result, d)), onError);
						if(first) promises.push(data.p = p); else return p;
					} else {
						return next(promise, d, first);
					}
				} catch(error) {
					onError(error);
				}
			}
			var onExternal = (external, _, first) => (external ? handleFunction(__webpack_require__.I, data[0], 0, external, onInitialized, first) : onError());
			var onInitialized = (_, external, first) => (handleFunction(external.get, data[1], getScope, 0, onFactory, first));
			var onFactory = (factory) => {
				data.p = 1;
				__webpack_require__.m[id] = (module) => {
					module.exports = factory();
				}
			};
			handleFunction(__webpack_require__, data[2], 0, 0, onExternal, 1);
		});
	}
}